const API_BASE_URL = 'https://kooturavu.tn.gov.in/api/v1/api';
// const API_BASE_URL = 'http://localhost:3000/api';

export const API_ENDPOINTS = {
  SOCIETY_TYPES: `${API_BASE_URL}/master/society_type`,
  DISTRICTS: `${API_BASE_URL}/master/list/district`,
  SOCIETY_LOCATIONS: `${API_BASE_URL}/society/location`,
};

export default API_BASE_URL;
